<template>
  <div class="form-group" :class="classFormGroup">
    <label v-if="label && labelPosition === 'top'" class="mb-2 d-block">
      {{ label }}
      <span v-if="required" style="color: red;"> *</span>
      <span v-if="validation?.$error" style="color: red; padding-left: 10px;">
        {{ messages }}
      </span>
      <span v-if="validationMessage" style="color: red; padding-left: 10px;">
        {{ validationMessage }}
      </span>
    </label>

    <label :class="[
      labelPosition === 'right' ? 'd-flex align-items-center' : '',
      disabled ? 'disabled' : ''
    ]">
      <input type="radio"
        :checked="id ? modelValue === id : modelValue" 
        :name="name" 
        @input="handleInput" 
        v-bind="$attrs"
        :style="inputStyle" class="me-2"
        :id="id" 
        :class="{ 'is-invalid': validation?.$error }"
        :disabled="disabled"
      />
      <div class="custom-check-icon"></div>
      <label v-if="label && labelPosition === 'right'" :for="id" class="mb-0">
        {{ label }}
        <span v-if="required" style="color: red;"> *</span>
        <span v-if="validation?.$error" style="color: red; padding-left: 10px;">
          {{ messages }}
        </span>
        <span v-if="validationMessage" style="color: red; padding-left: 10px;">
          {{ validationMessage }}
        </span>
      </label>
    </label>
  </div>
</template>

<script setup>
import { defineEmits, defineProps, toRefs } from 'vue';

const props = defineProps({
  modelValue: {
    type: [String, Number, null],
    required: true,
  },
  label: {
    type: [String, Boolean],
    default: false,
  },
  labelPosition: {
    type: String,
    default: 'top',
  },
  name: {
    type: String,
    required: false,
  },
  id: {
    type: String,
    required: false,
  },
  required: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  classFormGroup: {
    type: String,
    default: '',
  },
  validation: {
    type: Object,
    default: () => ({}),
  },
  messages: {
    type: [Object, String, Array],
    default: () => ({}),
  },
  validationMessage: {
    type: [String, null],
    default: '',
  },
  inputStyle: {
    type: Object,
  },
});

const emit = defineEmits(['update:modelValue']);
const { modelValue, id } = toRefs(props);

const handleInput = (event) => {
  emit('update:modelValue', id?.value ? event.target.id : event.target.checked);
};
</script>

<style scoped>
.mb-2 {
  margin-bottom: 0.5rem;
}

.me-2 {
  margin-right: 0.5rem;
}
</style>